export default __webpack_public_path__ + "226deada453552a4d4b92876c3446d77.svg";